module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "size": "mini",
      "inline": ""
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动ID",
      "prop": "id"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.id),
      callback: function($$v) {
        _vm.$set(_vm.form, "id", $$v)
      },
      expression: "form.id"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入"
    },
    model: {
      value: (_vm.form.activity_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "activity_name", $$v)
      },
      expression: "form.activity_name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动店铺",
      "prop": "shop_id"
    }
  }, [_c('el-select', {
    attrs: {
      "filterable": "",
      "remote": "",
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.shop_id),
      callback: function($$v) {
        _vm.$set(_vm.form, "shop_id", $$v)
      },
      expression: "form.shop_id"
    }
  }, _vm._l((_vm.shops), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动状态",
      "prop": "status"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, _vm._l((_vm.statusMap), function(label, value) {
    return _c('el-option', {
      key: value,
      attrs: {
        "label": label,
        "value": value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间",
      "prop": "time"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "clearable": "",
      "value-format": "yyyy-MM-dd",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.form.time),
      callback: function($$v) {
        _vm.$set(_vm.form, "time", $$v)
      },
      expression: "form.time"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.loadData(true)
      }
    }
  }, [_vm._v("搜索")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("重置")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "line"
  }), _vm._v(" "), _c('el-row', {
    staticClass: "pb20"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": function($event) {
        return _vm.edit(null)
      }
    }
  }, [_vm._v("新增")])], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.data,
      "border": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "活动ID",
      "prop": "id",
      "width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动名称",
      "prop": "activity_name",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动店铺",
      "prop": "shop_name",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动简介",
      "prop": "brief",
      "min-width": "160",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动开始时间",
      "prop": "begin_time",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "活动结束时间",
      "prop": "end_time",
      "width": "160"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "报名情况",
      "prop": "sign",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v(_vm._s(row.join_num) + " / " + _vm._s(row.number))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "签到情况",
      "prop": "check",
      "width": "120"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('div', [_vm._v("-")])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "状态",
      "prop": "statusTip",
      "width": "80",
      "fixed": "right"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "上线",
      "prop": "online",
      "width": "80",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;
        var rowIndex = ref.rowIndex;

        return [_c('el-switch', {
          attrs: {
            "value": !!(row.activity_status)
          },
          on: {
            "change": function($event) {
              return _vm.onShelfActivity(row)
            }
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "150",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var row = ref.row;

        return [_c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.detail(row)
            }
          }
        }, [_vm._v("查看")]), _vm._v(" "), (row.status == 0) ? _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.edit(row)
            }
          }
        }, [_vm._v("编辑")]) : _vm._e(), _vm._v(" "), _c('el-link', {
          attrs: {
            "type": "primary",
            "underline": false
          },
          on: {
            "click": function($event) {
              return _vm.joinDetail(row)
            }
          }
        }, [_vm._v("报名详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.form.page,
      "page-size": _vm.form.pageSize,
      "page-sizes": _vm.pageSizes,
      "prev-text": "上一页",
      "next-text": "下一页",
      "layout": "prev, next"
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c042f76"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/views/activity/list.vue
// module id = 922
// module chunks = 0